module.exports = __webpack_public_path__ + "68564b79df4dc1935ef22e449d4abbe6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/poly-bg/poly-bg-7.jpg
// module id = 396
// module chunks = 0